
export const getRowClassProperty = (
    parentRowNumber,
    currentRowNumber,
    isSubheader,
    currentCssClass,
    last = false
) => {
    const cssClasses = currentCssClass ? currentCssClass.split(" ") : [];

    if (parentRowNumber % 2 !== 0) {
        cssClasses.push("odd");
    }

    if (parentRowNumber !== currentRowNumber) {
        cssClasses.push("detail");
    }

    if (isSubheader) {
        cssClasses.push("subheader");
    }

    if (last) {
        cssClasses.push("last");
    }

    const properties = {};
    if (cssClasses.length > 0) {
        properties["className"] = cssClasses.join(" ");
    }
    return properties;
}

export const getTableClassProperty = (
    isPrint,
) => {
    const cssClasses = ["table"];
    if (isPrint) {
        cssClasses.push("is-print");
    }
    const properties = {};
    if (cssClasses.length > 0) {
        properties["className"] = cssClasses.join(" ");
    }
    return properties;
}

export const getTableSideProps = ({
    expanded_rows,
}, {
    ProjectedItems,
    SpouseName,
    SpouseAgeOptions,
    PrincipalName,
    isPrint,
}, {
    setExpanded,
}) => {
    const assetGroups = ProjectedItems[0].Assets.AssetGroups.slice();
    const liabilityGroups = ProjectedItems[0].Liabilities.LiabilityGroups.slice();
    let parity = 0;
    const next = (parity) => 1 - parity;
    const groups = [
        {
            name: "Assets",
            even: parity,
            items: assetGroups.map((assetGroup) => {
                parity = next(parity);
                return {
                    name: assetGroup.AssetGroup,
                    expanded: expanded_rows.includes(`Total|${assetGroup.AssetGroup}`),
                    onClick: setExpanded("Total", assetGroup.AssetGroup),
                    details: assetGroup.AssetDetails.map((detail) => ({
                        name: detail.Name,
                    })),
                    even: parity,
                }
            }),
        },
        {
            name: "Liabilities",
            even: next(parity),
            items: liabilityGroups.map((liabilityGroup) => {
                parity = next(parity);
                return {
                    name: liabilityGroup.LiabilityGroup,
                    expanded: expanded_rows.includes(`Total|${liabilityGroup.LiabilityGroup}`),
                    onClick: setExpanded("Total", liabilityGroup.LiabilityGroup),
                    details: liabilityGroup.LiabilityDetails.map((detail) => ({
                        name: detail.Name,
                    })),
                    even: next(parity),
                }
            }),
        },
        {
            name: "Net Worth",
            even: next(next(parity)),
            last: true,
            items: [],
        },
    ];

    return {
        groups,
        isPrint: isPrint,
        principalName: PrincipalName,
        hasSpouse: !!SpouseAgeOptions,
        spouseName: SpouseName,
    };
}
